import { Route, Routes, Link } from "react-router-dom";
import React, { useEffect, useRef } from "react";

import Compair from "../icons/Compair";
import QuickViewIco from "../icons/QuickViewIco";
import ThinLove from "../icons/ThinLove";
import newItemMark from "../../../images/newItemMark.svg";
//import preOrderMark from "../../../images/preorder.svg";
import "../../../../src/components/Helpers/icons/Badges.css";

function decodeHTMLEntities(text) {
  var txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value;
}

export default function ProductCardStyleOne({ datas, styleNumbers }) {
  const imgRef = useRef();
  const containerRef = useRef();

  const decodedDescription = decodeHTMLEntities(datas.shortDescription);

  // Fallback image in case the main image fails to load
  const handleError = () => {
    containerRef.current.style.background =
      "url(https://maevn-images.s3.us-east-2.amazonaws.com/220x220/NoImage.jpg) no-repeat center";
  };

  //Hide swatch images that failed to load
  const handleSwatchError = (event) => {
    event.target.style.display = "none";
  };

  // const collectionSlug = datas.productLine.replace(/ /g, "-");
  const rawCollectionSlug = datas.productLine.replace(/ /g, "-");

  const collectionSlug = rawCollectionSlug
    .toLowerCase()
    .includes("blaze-jacket")
    ? "Blaze"
    : rawCollectionSlug;

  console.log("collectionSlug : ", collectionSlug);

  // Check if styleNumber exists in styleNumbers array
  const momentumMensStyles = ["5801", "5802", "5861", "5891", "5892"];
  const styleNumbersArray = Array.isArray(styleNumbers)
    ? styleNumbers
    : [styleNumbers];
  const isMomentumMens = styleNumbersArray.some((num) =>
    momentumMensStyles.includes(String(num)),
  );

  return (
    <Link
      to={{
        pathname: isMomentumMens
          ? `/Momentum-Mens/${datas.styleNumber}/${datas.defaultColorCode}/${datas.fits[0]}`
          : `/${collectionSlug}/${datas.styleNumber}/${datas.defaultColorCode}/${datas.fits[0]}`,
      }}
    >
      <div
        className="product-card-one w-full h-full bg-white relative group overflow-hidden flex flex-col"
        style={{
          boxShadow: "0px 15px 64px 0px rgba(0, 0, 0, 0.05)",
        }}
      >
        {/*product list image*/}
        <>
          <img
            ref={imgRef}
            src={datas.listImageUrl}
            onError={handleError}
            alt=""
            style={{ display: "none" }}
          />
          <div
            ref={containerRef}
            className="product-card-img w-full h-[300px] mb-[-25px]"
            style={{
              background: `${
                datas.listImageUrl.length > 0 && datas?.listImageUrl
                  ? `url(${datas.listImageUrl}) no-repeat center`
                  : "url(https://maevn-images.s3.us-east-2.amazonaws.com/220x220/NoImage.jpg) no-repeat center"
              }`,
            }}
          />

          {/* Swatches */}
          <div className="px-[26px] mt-2 mb-3">
            <div className="swatches flex flex-wrap">
              {datas.colors.map((color) => {
                const colorCode = color.toLowerCase();
                const imageUrl = `https://maevn-images.s3.us-east-2.amazonaws.com/swatches/${colorCode}.jpg`;

                return (
                  <img
                    key={color}
                    src={imageUrl}
                    alt={color}
                    className="swatch-image  mr-1 mb-2"
                    onError={handleSwatchError}
                    style={{ width: "20px", height: "20px" }}
                  />
                );
              })}
            </div>
          </div>

          {/* Badges */}
          {(() => {
            const badges = [];

            // Discount badge should appear first if discountRate exists
            {
              /*
            const discountRate = Number(datas.discountRate || 0);

            if (Math.abs(discountRate) > 0) {
              badges.push(
                <div
                  key="discount-rate"
                  className="discountRateProductlist-badge"
                >
                  UP TO {Math.abs(discountRate)}%
                </div>,
              );
            }
            */
            }

            if (datas.isNew === 1) {
              badges.push(
                <div key="new-style" className="newStyleProductlist-badge">
                  NEW STYLE
                </div>,
              );
            } else if (datas.imageLinks?.some((image) => image.isNew === 1)) {
              badges.push(
                <div key="new-color" className="newColorProductlist-badge">
                  NEW COLORS
                </div>,
              );
            }

            if (datas.isPreorder === 1) {
              badges.push(
                <div key="is-preorder" className="preOrderProductlist-badge">
                  PREORDER
                </div>,
              );
            }

            return badges.length > 0 ? (
              <div className="absolute top-[10px] left-[20px]">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  {badges}
                </div>
              </div>
            ) : null;
          })()}
        </>

        {/* Original */}
        <div className="product-card-details px-[24px] pb-[30px] relative">
          <p className="title mb-2 text-[15px] font-600 text-qblack leading-[24px] line-clamp-2 hover:text-blue-600">
            {datas.erpProgramId === 4090
              ? `Embrace ${decodedDescription}`
              : decodedDescription}
          </p>
          <p className="text-sm text-qgray">Style no.{datas.styleNumber}</p>
          {/* </Link>*/}
          <p className="price flex flex-nowrap items-center gap-x-2 overflow-hidden whitespace-nowrap">
            {/* Discount check */}
            {datas.discountRate > 0 ? (
              <>
                <span className="font-600 text-[18px] text-red-500">
                  ${datas.priceMin} - ${datas.priceMax}
                </span>
                {/* Discouunt Price */}
                {/*
                <span className="font-600 text-[14px] line-through text-black whitespace-nowrap">
                  ${datas.priceMin} - ${datas.priceMax}
                </span>

                <span className="font-600 text-[14px] text-red-500 whitespace-nowrap">
                  ${datas.discountMin} - ${datas.discountMax}
                </span>
                */}
              </>
            ) : (
              <span className="font-600 text-[18px] text-red-500">
                ${datas.priceMin} - ${datas.priceMax}
              </span>
            )}
          </p>
        </div>
      </div>
    </Link>
  );
}
